export function RenderHiddenField({ name, type, ...rest }) {
  return <input type={type} name={name} {...rest} style={{ display: "none" }} />;
}
